/* import __COLOCATED_TEMPLATE__ from './flag-user-modal.hbs'; */
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import LSGModalBase from './lsg/lsg-modal-dialog-base';
import { closeModal } from 'sh-www/utils/modal-controls';
import { handleErrorResponseWithModal, clearErrors, setErrors } from 'sh-www/utils/handles-errors';
import { REPORT_USER_API_REASONS } from "../../services/commands/thread-commands";

export default LSGModalBase.extend({
  /**
   * Register Services
   */
  threadCommandService : service('commands/thread-commands'),
  session: service(),

  currentUser: readOnly('session.currentUser'),

  /**
   * @inheritDoc
   */
  propertyDefaults: {
    /**
     * The thread id of the report in question.
     *
     * @type {String|null}
     */
    threadId: null
  },

  /**
   *
   *
   * @type {String}
   */
  _getPaidOutsidePlatformMesssage: computed('currentUser.isSeller', function() {
    return this.get('currentUser.isSeller') ?
      'They are trying to pay outside of the Glimmer website' :
      'They are trying to get paid outside of the Glimmer website';
  }),

  /**
   * @type {Boolean}      True when submitting the form.
   */
  _isSubmitting: false,

  /**
   * @type {Boolean}      True when the form has been saved successfully.
   */
  _isSuccess: false,

  /**
   * The message the user has written.
   *
   * @type {String}
   */
  _message: '',

  /**
   * Various constants for the reportUserReasons that we'll use for the value of the radio buttons
   *
   * @type {String}   of REPORT_USER_API_REASONS
   */
  _reportUserReasonOffensiveLanguage: REPORT_USER_API_REASONS.OFFENSIVE_LANGUAGE,
  _reportUserReasonOffsitePayment: REPORT_USER_API_REASONS.OFFSITE_PAYMENT,
  _reportUserReasonOther: REPORT_USER_API_REASONS.OTHER,

  /**
   * The value of the radio button the user selected
   *
   * @type {String|null}
   */
  _reportUserValueSelected: null,

  init() {
    this._super(...arguments);
    this.set('errors', {});
  },

  /**
   * @inheritDoc
   */
  _onClose() {
    this.set('_reportUserValueSelected', null);
    this.set('_message', '');
    this.set('_isSuccess', false);
    this.set('_isSubmitting', false);
    clearErrors(this);
  },

  /**
   * @inheritDoc
   */
  actions: {
    /**
     * Called when the user confirms to save the report abuse form.
     */
    onReportConfirmed: function() {
      let message = this.get('_message'),
        reason = this.get('_reportUserValueSelected');

      clearErrors(this);
      if (!message || !reason) {
        setErrors(this, { 'generic-exception-message': 'You must enter a message and select a reason' }, ['generic-exception-message'], true);
        return;
      }

      this.set('_isSubmitting', true);
      this.get('threadCommandService').reportThread(this.get('model.threadId'), reason, message).then(() => {
        this.set('_isSuccess', true);
      }).catch(e => handleErrorResponseWithModal(this, e))
        .finally(() => this.set('_isSubmitting', false));
    },

    /**
     * When one of the radio buttons is clicked.
     *
     * @param {String} val      of type REPORT_USER_API_REASONS.*
     */
    reportReasonRadioClicked: function(val) {
      this.set('_reportUserValueSelected', val);
    },

    closeModal() {
      closeModal(this);
    },
  }
});
